<template>
    <label class="w-full md:w-[48%] lg:w-[31.5%] 2xl:w-[32%] cursor-pointer">
        <input type="checkbox" v-model="check" class="peer hidden" @change="toggleCheck" />
        <div class="rounded-[12px] 2xl:rounded-[20px] p-2 2xl:p-4 bg-white shadow-[0px_0px_10px_0px_#00000026;]">
            <div class="flex items-center justify-between">
                <span v-if="sharePlanDetail.category == 'bundle'"
                    class="flex items-center text-[14px] 2xl:text-[20px] font-roboto font-bold text-[#42ADFF]">
                    <span class="w-1 h-1 2xl:w-2 2xl:h-2 bg-[#42ADFF] rounded-full mr-1 2xl:mr-2"></span>
                    <span class="w-6 h-1 2xl:w-8 2xl:h-2 bg-[#42ADFF] rounded-full mr-2"></span>
                    New Bundle
                </span>
                <span v-else
                    class="flex items-center text-[14px] 2xl:text-[20px] font-roboto font-bold text-purple-500">
                    <span class="w-1 h-1 2xl:w-2 2xl:h-2 bg-purple-500 rounded-full mr-2"></span>
                    <span class="w-6 h-1 2xl:w-8 2xl:h-2 bg-purple-500 rounded-full mr-2"></span>
                    New Plan <span class="ml-1.5 2xl:ml-3 text-gray-400 text-[12px] 2xl:text-[14px] font-normal">({{
                        sharePlanDetail.trade_title
                        }})</span>
                </span>
                <span class="w-5 h-5 2xl:w-6 2xl:h-6 flex items-center justify-center">
                    <img v-if="!check" src="../../assets/images/sharePlanunCheckIcon.svg" alt="Unchecked" />
                    <img v-else src="../../assets/images/sharePlancheckIcon.svg" alt="Checked" />
                </span>
            </div>
            <h3
                class="my-1.5 2xl:my-3 text-[16px] 2xl:text-[20px] font-bold font-roboto text-[#333333] leading-[1.2] tablet:min-h-[35px] tablet:max-h-[35px] 2xl:min-h-[45px] 2xl:max-h-[45px]">
                {{ truncate(sharePlanDetail.title, 100) }}
            </h3>
            <p class="m-0 text-[14px] 2xl:text-[18px] font-medium font-roboto text-[#EA8A8A]">
                {{ sharePlanDetail.term_months }} months plan</p>
            <p class="m-0 text-[22px] 2xl:text-[32px] font-bold font-roboto leading-tight text-[#333333]">
                ${{ sharePlanDetail.amount }}<span
                    class="text-[16px] 2xl:text-[30px] font-bold text-[#333333]">/mo</span>
            </p>
        </div>
    </label>
</template>

<script>
export default {
    name: "SharePlanCard",
    props: ["sharePlanDetail", "reset"],
    data() {
        return {
            check: false,
        };
    },
    watch: {
        reset: function (data) {
            this.check = false
        },
    },
    methods: {
        toggleCheck() {
            this.$emit("toggle", {
                item: {
                    "plan_id": this.sharePlanDetail.id,
                    "plan_type": this.sharePlanDetail.category
                }, checked: this.check
            });
        },
        truncate(text, length) {
            if (!text) return "";
            return text.length > length ? text.substring(0, length) + "..." : text;
        }
    },
};
</script>
